const
  NAME               = 'molinillo',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class Molinillo {
  constructor(element$) {
    this._element$ = element$;
    element$.find('.voc-molinillo-btn').on('click', (e) => this.onClick(e));
  }

  onClick(/*event*/) {
    this._element$.animate({'opacity':'0'}, 'slow');
    this._element$.slideToggle('slow');
  }

  static get VERSION() {
    return VERSION;
  }

  /**
   * This method is required to register the plugin as jQuery Plugin
   */
  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new Molinillo($(this));
    });
  }
}

$.fn[NAME]             = Molinillo._jQueryInterface;
$.fn[NAME].Constructor = Molinillo;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return Molinillo._jQueryInterface;
};

export default Molinillo;



// WEBPACK FOOTER //
// ./src/plugins/molinillo.js